import { useEffect } from 'react';

export const usePreventScroll = (isEnabled: boolean) => {
  useEffect(() => {
    if (isEnabled) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isEnabled]);
};
